import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

import { DistributionCommon } from './distribution-common'

const LINES = [1, 2, 3, 4, 5]

export const DistributionSkeleton = () => (
  <DistributionCommon>
    <Root>
      <Header>
        <Skeleton width="16%" height="38px" />
        <Skeleton width="34%" height="38px" />
        <Skeleton width="20%" height="38px" />
        <Skeleton width="35%" height="38px" />
      </Header>
      <Body>
        {LINES.map((x) => (
          <RowSkeleton key={x} />
        ))}
      </Body>
    </Root>
  </DistributionCommon>
)

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

const Header = styled.div`
  display: flex;
  gap: 12px;
`

const Body = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  align-items: center;
`

const RowSkeleton = () => (
  <>
    <Skeleton width="12px" height="12px" />
    <Skeleton.Line width={Skeleton.between(40, 80) + 'px'} />
    <ValueSkeleton width={Skeleton.between(30, 50) + 'px'} />
  </>
)
const ValueSkeleton = styled(Skeleton.Line)`
  text-align: right;
  justify-self: end;
`
